<template>
    <div class="cust-xport-conf-crud">
        <div style="border-bottom: 1px dashed #EEEEEE;height: 40px; padding: 5px 10px; line-height: 30px;">
            <span>导入模板【{{confTitle}}】- {{confUsage}} 定制化</span>
            <span style="float:right;">
                Sheet页表：
                <el-select v-model="curSheetName" placeholder="切换 模板页表" @change="setCurSheetFieldList()">
                    <el-option v-for="sheetName in dataSheetNames" :label="sheetName" :value="sheetName"></el-option>
                </el-select>
                <span style="margin-left: 40px;"><el-checkbox v-model="showColPreview">显示列预览</el-checkbox></span>
            </span>
        </div>
        <div>
            <div v-show="showColPreview" style="width: 100%;margin-top: 10px;overflow-x: auto">
                <table class="simple-tbl">
                    <tbody class="body">
                    <tr style="height: 28px;line-height: 28px;" class="row">
                        <td class="cell" v-if="field.selected" v-for=" field in curSheetFieldList" style="cursor: default">
                            <el-tooltip class="item" effect="dark" :open-delay="500" :content="field.name" placement="top">
                                <span :style="{ 'fontWeight' : field.required ? 'bold' : 'normal', 'color' : field.required ? '#000000' : '#333333'}">{{field.title}}</span>
                            </el-tooltip>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-for="logicGroup in curSheetLogicGroups" style="padding : 10px;">
                <el-divider content-position="left"><span style="font-weight: bold;">{{logicGroup}}</span></el-divider>
                <div class="group-tags">
                    <el-tooltip v-for="(field, index) in curSheetGroupedFields[logicGroup]" :key="field.name" class="item" effect="dark" :open-delay="1000" :content="field.name" placement="top">
                        <el-tag @click="switchFieldSelection(logicGroup, field, index)" :class="{'required' : field.required, 'selectable' : editMode && !field.required, 'selected' : field.selected}" style="text-align: center; margin-right: 10px;margin-bottom:10px; display: inline-block; min-width : 100px;">
                            {{field.title}}
                        </el-tag>
                    </el-tooltip>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils, Jqext } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import SwbDtPopover from '../ctrl/DtPopover.vue';

    let Toast = Jqext.Toast;
    export default {
        components: {SwbDtPopover},
        name: 'swb-cust-xport-conf-crud',
        desc: '导入/导出配置定制',
        props: {
            editMode: {
                type: Boolean,
                default: false
            },
            //元数据配置（基础配置 + 补充配置）
            metaConf: {
                type: Object
            },
            //定制配置信息 { sheetName => fieldNames }
            custConf: {
                type: Object
            },
            height: {
                type: Number,
                default: 600,
            }
        },
        data: function () {
            return {
                showColPreview: false,
                //
                confUsage: '',
                confTitle: '<未知>',
                //数据sheet名称（列表选择）
                dataSheetNames: [],
                //数据sheet fields Map { sheetName => fieldList }
                dataSheetFieldsMap: {},

                //当前sheet名称
                curSheetName: null,
                //当前sheet所有字段
                curSheetFieldList: [],
                //当前sheet 逻辑分组 [logicGroup]
                curSheetLogicGroups: [],
                //当前sheet {logicGroup => fieldList}
                curSheetGroupedFields: {}
            };
        },
        watch: {
            height(newVal, oldVal) {
                //this.setHeights();
            }
        },
        created() {

        },
        destroyed() {

        },
        mounted() {
            this.doInit();
        },
        methods: {
            setHeights() {
                //
            },
            doInit() {
                console.log('---- metaConf ----');
                console.log(this.metaConf);
                console.log('---- custConf ----');
                console.log(this.custConf);
                //
                let metaConf = this.metaConf || {};
                let custConf = this.custConf || {};
                let sheetList = metaConf.sheetList || [];
                //
                this.confUsage = metaConf.usage;
                this.confTitle = metaConf.title;
                //
                let curSheetName = null;
                let dataSheetNames = [];
                let dataSheetFieldsMap = {};
                for(let i = 0, c = sheetList.length; i < c; i++) {
                    let sheet = sheetList[i];
                    if(sheet.listSrcFlag) {
                        //忽略下拉列表源sheet
                        continue;
                    }
                    let sheetName = sheet.name;
                    dataSheetNames.push(sheetName); //
                    if(curSheetName == null) {
                        curSheetName = sheetName;
                    }
                    //
                    let fieldList = sheet.fieldList || [];
                    dataSheetFieldsMap[sheetName] = fieldList; //
                    //定制的sheet选择的字段名称列表
                    let custSheetFieldNames = custConf[sheetName] || [];
                    if(custSheetFieldNames.length == 0) {
                        //无定制的sheet选择字段，则全部选中
                        for(let k = 0, kc = fieldList.length; k < kc; k++) {
                            let field = fieldList[k];
                            field.selected = true;
                        }
                    }
                    else {
                        for(let k = 0, kc = fieldList.length; k < kc; k++) {
                            let field = fieldList[k];
                            if(field.required || custSheetFieldNames.indexOf(field.name) != -1) {
                                //包含在定制字段中
                                field.selected = true;
                            }
                        }
                    }
                }
                //
                this.dataSheetFieldsMap = dataSheetFieldsMap;
                this.dataSheetNames = dataSheetNames;
                this.curSheetName = curSheetName;
                //
                this.setCurSheetFieldList();
            },
            //
            setCurSheetFieldList() {
                let curSheetFieldList = this.dataSheetFieldsMap[this.curSheetName] || [];
                let curSheetLogicGroups = [];
                let curSheetGroupedFields = {};
                for(let i = 0, c = curSheetFieldList.length; i < c; i++) {
                    let field = curSheetFieldList[i];
                    let logicGroup = field.logicGroup || '';
                    logicGroup = logicGroup.trim() || '其他';
                    if(curSheetLogicGroups.indexOf(logicGroup) == -1) {
                        curSheetLogicGroups.push(logicGroup);
                        curSheetGroupedFields[logicGroup] = [];
                    }
                    curSheetGroupedFields[logicGroup].push(field);
                }
                //把”其他“组放到最后
                let otherIndex = curSheetLogicGroups.indexOf('其他');
                if(otherIndex != -1) {
                    curSheetLogicGroups.removeAt(otherIndex);
                    curSheetLogicGroups.push('其他');
                }
                //
                this.curSheetFieldList = curSheetFieldList;
                this.curSheetGroupedFields = curSheetGroupedFields;
                this.curSheetLogicGroups = curSheetLogicGroups;
            },
            switchFieldSelection(logicGroup, field, fieldIndex) {
                if(this.editMode && !field.required) {//编辑模式 + 非必须才可切换选择状态
                    let curSheetGroupedFields = this.curSheetGroupedFields;
                    let fields = curSheetGroupedFields[logicGroup];
                    field.selected = !field.selected;
                    this.$set(fields, fieldIndex, field);
                }
            },
            getCustConf() {
                let dataSheetFieldsMap = this.dataSheetFieldsMap;
                let custConf = {};
                for(let sheetName in dataSheetFieldsMap) {
                    let fields = dataSheetFieldsMap[sheetName];
                    let selectedFieldNames = [];
                    custConf[sheetName] = selectedFieldNames;
                    for(let i = 0, c = fields.length; i < c; i++) {
                        let field = fields[i];
                        if(field.selected) {
                            selectedFieldNames.push(field.name);
                        }
                    }
                }
                //
                return custConf;
            }
        }
    }
</script>

<style>
    .cust-xport-conf-crud .group-tags .el-tag {
        background-color: #FFFFFF;
        color: #333333;
        border-color: #CCCCCC;
        border-style: dashed;
        cursor: default;
    }

    .cust-xport-conf-crud .group-tags .el-tag.selected {
        border-color: #409EFF;
        border-style: solid;
    }

    .cust-xport-conf-crud .group-tags .el-tag.required {
        cursor: not-allowed;
        font-weight: bold;
    }

    .cust-xport-conf-crud .group-tags .el-tag.required.selected {
        color: #000000;
        background-color: #eff5ff;
    }

    .cust-xport-conf-crud .group-tags .el-tag.selectable {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/compo/comn/CustXportConfCrud.vue